<template>
    <div class="package-buttons__wrapper">
        <template v-if="!componentLoaded">
            <!-- remove this comment -->
            <div>
                <div>
                    <div>
                        <a href="#" rel="nofollow"
                           alt="Loading" title="Loading"
                           class="button button-high button-primary hidden-on-mobile">
                            <span class="button-label">Zugriff auf alle Inhalte</span>
                        </a>
                    </div>
                    <span class="button-text-small hidden-on-mobile">In der Mitgliedschaft ab <strong>* € monatlich</strong></span>
                </div>
            </div>
            <div>
                <div class="oder hidden-on-mobile">{{ t.frontend.or }}</div>
                <div class="bottom-sticky-on-mobile">
                    <div>
                        <a rel="nofollow noreferrer noopener" alt="Loading"
                           title="Loading" id="add-to-cart"
                           class="button button-high button-alternate">
                            <span class="button-label">Inhalt in den Warenkorb</span>
                        </a>
                    </div>
                    <span class="button-text-small">Sofort-Download nach Kauf: <strong>einmalig * €</strong></span>
                </div>
            </div>
        </template>
        <div v-cloak v-for="(button, key) in buttons" :key="key">
            <div class="oder hidden-on-mobile" v-if="key == 'blue' && button">
                {{ t.frontend.or }}
            </div>
            <div :class="key == 'blue' ? 'bottom-sticky-on-mobile' : ''">
                <span class="cart-marketing" v-if="button.text_marketing" v-html="button.text_marketing"></span>
                <img src="/images/discount.svg" v-if="button.text_marketing">
                <div v-if="button.type && button.type == 'download'">
                    <a
                        v-if="zipUrl"
                        :href="auth ? button.url : ''"
                        :id="
                            button.id && {
                                'button-download-package': auth,
                                'button-download-package-required-login': !auth,
                            }
                        "
                        :alt="button.tooltip"
                        :title="button.tooltip"
                        class="button button-high"
                        :class="{
                            'button-alternate': key == 'blue',
                            'button-primary': key != 'blue',
                        }"
                    >
                        <span class="button-label">
                            {{ button.text_button }}
                            <span v-if="button.text_button_small && auth && download > 0">
                                {{ button.text_button_small }}
                            </span>
                        </span>
                    </a>
                </div>
                <div v-else-if="button.text_button">
                    <a
                        :href="button.url"
                        rel="nofollow"
                        :alt="button.tooltip"
                        :title="button.tooltip"
                        :id="button.id"
                        class="button button-high"
                        :class="{
                            'button-alternate': key == 'blue',
                            'button-primary hidden-on-mobile': key != 'blue',
                        }"
                        :data-package="button.data_package"
                        @click.prevent="button.data_package ? addToCart(button.data_package) : goToHref(button.url)"
                    >
                        <span class="button-label">
                            {{ button.text_button }}
                            <span v-if="button.text_button_small">
                                {{ button.text_button_small }}
                            </span>
                        </span>
                    </a>
                </div>
                <span
                    class="button-text-small"
                    :class="{
                        'hidden-on-mobile': key != 'blue',
                    }"
                    v-if="button.text_small"
                    v-html="button.text_small"
                ></span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "@/app/axios.ts"
const translationsData = window.translationsData
export default {
    name: "PackageButtons",
    props: ["zipUrl", "selectedPackageId", "languageCode"],
    data() {
        return {
            buttons: [],
            scrollListenerActive: false,
            t: translationsData.translations,
            globalRoute: translationsData.global_route,
            auth: false,
            download: false,
            voucherId: false,
            componentLoaded: false
        }
    },
    created() {
        this.getButtons()
        this.fixButtonToTheBottom()
    },
    mounted() {
    },
    methods: {
        goToHref(href) {
            window.location.href = href
        },
        async addToCart(packageId) {
            if (packageId) {
                try {
                    const response = await axios.post(this.globalRoute.cart + "/add", {
                        package_id: packageId,
                        frontend_voucher_id: this.voucherId,
                    })
                    if (response) {
                        window.location.href = this.globalRoute.cart
                    }
                } catch (e) {
                    this.$error(e)
                }
            }
        },
        async getButtons() {
            const headers = {
                "Content-Type": "application/json; charset=UTF-8",
                "X-CSRF-TOKEN": document.querySelector("meta[name=csrf-token]").content,
                "X-Robots-Tag": "noindex, nofollow",
            }

            await axios
                .post(
                    "/" + this.languageCode + "/package/get-buttons",
                    {
                        package_id: this.selectedPackageId,
                    },
                    {
                        headers: headers,
                    },
                )
                .then((response) => {
                    this.buttons = response.data.buttons
                    this.auth = response.data.auth
                    this.download = response.data.download
                    this.voucherId = response.data.voucherId
                    this.componentLoaded = true
                })
        },

        fixButtonToTheBottom() {
            function fixingBtnHandler() {
                let fixedBtnOnMobile = document.querySelector(".hidden-desktop .bottom-sticky-on-mobile")
                let btnsContainer = document.querySelector(".hidden-desktop.package-buttons")
                if (fixedBtnOnMobile) {
                    let distanceFromTop = btnsContainer.getBoundingClientRect().top
                    if (distanceFromTop <= window.innerHeight - 20) {
                        fixedBtnOnMobile.classList.add("sticked")
                        if (fixedBtnOnMobile.classList.contains("static-position")) {
                            fixedBtnOnMobile.classList.remove("static-position")
                        }
                    } else {
                        fixedBtnOnMobile.classList.remove("sticked")
                    }
                }
            }

            if (!this.scrollListenerActive) {
                window.addEventListener("scroll", fixingBtnHandler)
                this.scrollListenerActive = true
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.hidden-on-mobile {
    @media (width <= 575px) {
        display: none !important;
    }
}

.bottom-sticky-on-mobile {
    position: relative;

    @media (width <= 575px) {
        transition: 0.3s ease-in-out;
        position: fixed;
        bottom: 0;
        z-index: 100;
        transform: translateY(100%);
        opacity: 0;
        width: 100%;
        padding: 10px 15px 5px;
        left: 0;
        background: var(--color-off-white);
    }

    &.sticked {
        @media (width <= 575px) {
            transform: translateY(0);
            opacity: 1;
            transition: 0.3s ease-in-out;
        }
    }

    &.static-position {
        @media (width <= 575px) {
            position: static;
            padding: 0;
            background: none;
            transform: translateY(0);
            opacity: 1;
            transition: 0.3s ease-in-out;
        }
    }

    .button {
        @media (width <= 575px) {
            margin-bottom: 5px;
        }
    }
}

.package-buttons__wrapper {
    @media (width >= 576px) and (width <= 991px) {
        justify-content: center;
        padding-top: 30px;
    }

    .button {
        @media (width >= 576px) and (width <= 991px) {
            margin-bottom: 5px;
        }
    }
}

.cart-marketing {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    font-size: var(--font-size-smaller);
    line-height: 15px;
    color: #FF0000;
    transform: translateY(-100%);
    padding-bottom: 5px;
    padding-left: 25px;
    white-space: normal;
    z-index: 10;

    @media (width <= 575px) {
        position: static;
        transform: translate(0, 0);
        line-height: var(--line-height-extra-small);
    }

    @media (min-width: 1475px) {
        margin-right: -30px;
    }
}

img {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(-50%, -50%);
    z-index: 10;

    @media (width <= 575px) {
        transform: translate(0, 0);
        top: auto;
        bottom: 65px;
    }
}
</style>
